"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bullet = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
function Bullet(_a) {
    var isCurrent = _a.isCurrent, isInitial = _a.isInitial, index = _a.index;
    var bulletStyle = "gd-resize-bullet s-resize-bullet-" + index;
    return (react_1.default.createElement("div", { className: bulletStyle },
        react_1.default.createElement("svg", { className: "gd-resize-bullet-icon" },
            react_1.default.createElement("circle", { cx: "3", cy: "3", r: "3", className: classnames_1.default({
                    active: isCurrent,
                    initial: isInitial,
                    passive: !isCurrent && !isInitial,
                }) }))));
}
exports.Bullet = Bullet;
//# sourceMappingURL=Bullet.js.map